import React, { useEffect } from 'react';

import { logoutRouteConfig } from 'src/app/onboarding/routes';
import { Loading } from 'src/components/common/loading/Loading';
import { useAuth } from 'src/context/AuthContext';
import { useRouteParams } from 'src/hooks/useRouteParams';
import Config from 'src/lib/config';

export const LogoutPage = () => {
  const { logout } = useAuth();
  const { callbackUrl = Config.absoluteUrl } =
    useRouteParams(logoutRouteConfig);

  useEffect(() => {
    logout(callbackUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Loading />;
};
